import { type Campaign } from './types';
import { ListViewCampaignCard } from './ListViewCampaignCard';

interface CampaignListViewTabProps {
    campaigns: Campaign[];
    onEdit?: (campaignId: string) => void;
    onView?: (campaignId: string) => void;
    onDelete?: (campaignId: number) => void;
    onGenerateBrief?: (campaign: Campaign) => void;
    isGeneratingBrief?: boolean;
    generatingBriefCampaignId?: number;
    canEdit?: boolean;
    canDelete?: boolean;
}

export function CampaignListViewTab({
    campaigns,
    onEdit,
    onDelete,
    onView,
    onGenerateBrief,
 isGeneratingBrief,
 generatingBriefCampaignId,
 canEdit,
    canDelete
}: CampaignListViewTabProps) {
  return (
        <div className="space-y-4">
            <div>
      <h3 className="text-lg font-semibold text-[#3e2723]">All Campaigns</h3>
    <p className="text-sm text-gray-500">A detailed overview of every campaign that matches the selected filters.</p>
  </div>

            {campaigns.length > 0 ? (
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
     {campaigns.map((campaign) => (
                <ListViewCampaignCard
                    key={campaign.id}
                    campaign={campaign}
                    showDeleteButton={true}
                    showEditButton={true}
                    onEdit={onEdit}
                    onView={onView}
                    onDelete={onDelete}
                    onGenerateBrief={onGenerateBrief}
                    isGeneratingBrief={isGeneratingBrief}
                    generatingBriefCampaignId={generatingBriefCampaignId}
                    canEdit={canEdit}
     canDelete={canDelete}
   />
     ))}
       </div>
  ) : (
      <div className="py-12 text-center text-gray-500">
              <p>No campaigns found for the selected filters.</p>
     <p className="mt-1 text-sm">Try adjusting your filters or create a new campaign.</p>
            </div>
    )}
        </div>
    );
}
